<template>
    <section>
        <SearchedFbaProduct
            v-for="searchedFbaProduct in searchedFbaProducts"
            :key="searchedFbaProduct.id"
            :searched-fba-product="searchedFbaProduct"
        />
    </section>
</template>
    <script>
    import { mapState } from 'vuex'
    import SearchedFbaProduct from '@/views/amazon/fba-basket/SearchedFbaProduct.vue'

    export default {
        name: 'SearchedFbaProducts',
        components: {
            SearchedFbaProduct,
        },
        computed: {
            ...mapState('azFbaBasket', ['searchedFbaProducts']),
        },
    }
    </script>
